/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sw_readOnly[_ngcontent-%COMP%], .wizard-metadatas[_ngcontent-%COMP%]{width:100%}.list-group-item[_ngcontent-%COMP%]{background-color:transparent;border:0;padding:0 0 .25rem}"];
export { styles as styles };
